import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
  const bonuses = [{
    title: 'Cómo saber si tu celular está hackeado',
    img: 'https://cdn.magicpatterns.com/uploads/gnHnzv7RxzNHhw4TJfdHCR/BONO_1_(3).png'
  }, {
    title: 'Configuración de seguridad paso a paso',
    img: 'https://cdn.magicpatterns.com/uploads/3xneMAAjmJq1SDbtdvAi9g/BONO_2.jpg'
  }, {
    title: '20 estafas digitales reales',
    img: 'https://cdn.magicpatterns.com/uploads/npBxsYgTw2dnZgEktrs8Sg/B0N0_3.jpg'
  }];
  return <section className="bg-[#0B0B1A] py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-14">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-[#FF00FF] opacity-10 blur-[150px] pointer-events-none" data-id="element-15" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-block bg-[#FF3333] text-white px-8 py-3 rounded-full font-extrabold text-2xl md:text-4xl mb-6 shadow-[0_0_30px_rgba(255,51,51,0.5)]" data-id="element-18">
            🎁 BONOS GRATIS - SOLO POR HOY
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-19">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col items-center text-center group cursor-pointer hover:bg-white/10 transition-colors" onClick={scrollToPricing} data-id="element-20">
              <div className="w-full aspect-square mb-6 overflow-hidden rounded-xl relative" data-id="element-21">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-22" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center" data-id="element-23">
                  <span className="opacity-0 group-hover:opacity-100 bg-[#00FF66] text-black font-bold px-4 py-2 rounded-full transition-opacity shadow-lg text-sm" data-id="element-24">
                    Incluido Gratis
                  </span>
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-2 flex items-center justify-center gap-2" data-id="element-25">
                <span className="text-[#FF00FF]" data-id="element-26">🎁</span> {bonus.title}
              </h3>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-27">
          <p className="text-2xl md:text-3xl font-bold text-[#00D4FF]" data-id="element-28">
            Todo explicado de forma simple y fácil de aplicar.
          </p>
        </div>
      </div>
    </section>;
}